'use client';

import { useEffect } from 'react';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';
import { toast } from '@/components/storefront/ui/toast';
import { useTranslations } from 'next-intl';

export function VerifiedToast() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations('auth');

  useEffect(() => {
    if (searchParams.get('verified') === 'true') {
      toast.success(t('welcomeVerified'));
      // Remove the query param from the URL without a page reload
      const params = new URLSearchParams(searchParams.toString());
      params.delete('verified');
      const newUrl = pathname + (params.toString() ? '?' + params.toString() : '');
      router.replace(newUrl);
    }
  }, [searchParams, pathname, router, t]);

  return null;
}
